import Container from '@mui/material/Container';

import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { PageHelmet } from '../components';
import { InventoryHeader } from '../features/inventory';
import { InventoryTable } from '../features/inventory/components/Table';
import { TransferVariant } from '../features/inventory/components/TransferVariants/TransferVariant';
import { InventoryTotalsHeader } from '../features/inventory/components/InventoryTotalHeader';

const InventoryPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.INVENTORY}>
    <Container
      sx={{
        px: { xs: 0, lg: 2 },
      }}
      maxWidth={false}
    >
      <InventoryHeader />
      <InventoryTotalsHeader />
      <InventoryTable />
      <TransferVariant />
    </Container>
  </PageHelmet>
);

export default InventoryPage;
